/* eslint-disable max-len */
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import TextBox from '../../../components/textbox';

const DisabledPolitician = ({ classes }) => (
  <div className={classes.root}>
    <Typography variant="h4" color="primary" gutterBottom>Politikerbasen i Trondheim kommune</Typography>
    <Divider className={classes.divider} />
    <TextBox title="Deaktivert profil">
      <Typography variant="body1">
        Profilen din er deaktivert. Ta kontakt med en administrator dersom du ønsker å aktivere profilen på nytt.
      </Typography>
    </TextBox>
  </div>
);

const styles = () => ({
  root: {
    maxWidth: '50rem',
    marginBottom: '4rem',
  },
  divider: {
    marginBottom: '1rem',
  },
});

DisabledPolitician.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(DisabledPolitician));
